import React, { useEffect, useState } from "react";
import Container from "./PvinContainer";

// Loader placeholder
const Loader = () => (
  <div className="text-center py-4 text-gray-600 animate-pulse">
    Loading fleet summary...
  </div>
);

const FleetSummary = ({ data }) => {
  const [showLoader, setShowLoader] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);

  useEffect(() => {
    // Mark that data has loaded (even if empty)
    if (data !== undefined) {
      setHasLoaded(true);
    }

    // If data is present, show loader briefly
    if (data && Object.keys(data).length > 0) {
      setShowLoader(true);
      const timeout = setTimeout(() => {
        setShowLoader(false);
      }, 800); // adjust loader duration as needed

      return () => clearTimeout(timeout);
    }
  }, [data]);

  // Case: Data is still loading → show nothing
  if (!hasLoaded) {
    return null; // or full page loader if needed
  }

  // Case: Data has loaded, but it's missing or empty
  if (!data || Object.keys(data).length === 0) {
    return (
      <Container>
        <h2 className="text-xl font-semibold mb-2">Fleet Summary</h2>
        <div className="text-sm text-red-600">
          No subscription data available.
        </div>
      </Container>
    );
  }

  // Case: Data is present but loader is active
  if (showLoader) {
    return (
      <Container>
        <h2 className="text-xl font-semibold mb-2">Fleet Summary</h2>
        <Loader />
      </Container>
    );
  }

  // Case: Render actual fleet summary
  return (
    <Container>
      <h2 className="text-xl  font-semibold ">Fleet Summary</h2>
      <div className="space-y-3 text-md mb-2 font-medium">
        <div className="flex justify-between">
          <span className="text-gray-700 font-semibold ml-2">
            TML Fleet Size :
          </span>
          <span className="text-black mr-2">{data?.Fleetsize}</span>
        </div>
        <div className="flex justify-between bg-gray-100 p-2 rounded ml-2">
          <span className="text-gray-700 font-semibold">
            Last Purchase date :
          </span>
          <span className="text-black mr-1">{data?.last_purchase_date_op}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-700 font-semibold ml-3">
            Last Purchase Model:
          </span>
          <span className="text-black mr-2">
            {data?.last_purchase_model_value || "-"}
          </span>
        </div>
        <div className="flex justify-between bg-gray-100 p-2 rounded">
          <span className="text-gray-700 font-semibold ml-2">
            Purchase Qty :
          </span>
          <span className="text-blue-600 mr-2">
            {data?.purchase_qty_value}
          </span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-700 font-semibold ml-3">
            Last 6 Months Purchase Qty :
          </span>
          <span className="text-blue-600 mr-4">
            {data?.last_six_month_value}
          </span>
        </div>
      </div>
    </Container>
  );
};

export default FleetSummary;
